module.exports = __webpack_public_path__ + "static/klinkovska-6c3e19f064e961b0b37a2bc784e912f8.jpg";